"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMsalClient = exports.get = void 0;
const msal_browser_1 = require("@azure/msal-browser");
const config_1 = __importDefault(require("../../../build-babel/auth/client/config"));
const handler_1 = __importDefault(require("../../../build-babel/auth/response/handler"));
const error_1 = __importDefault(require("../../../build-babel/auth/response/error"));
const session_1 = require("../../../build-babel/session");
const removeLocalStorageCache = () => {
  // ITWMDIO-2622: temporary fix
  for (let i = 0; i < localStorage.length; i++) {
    const localStorageItemKey = localStorage.key(i);
    if (localStorageItemKey && localStorageItemKey.indexOf('b2c_1a') !== -1) {
      localStorage.removeItem(localStorageItemKey);
    }
  }
};
const enableLoginLogoutSyncAcrossTabs = msalClient => {
  //enable account storage event
  msalClient.enableAccountStorageEvents();
  msalClient.addEventCallback(message => {
    if (message.eventType === msal_browser_1.EventType.ACCOUNT_REMOVED) {
      (0, session_1.removeSession)(window.location.href);
    }
  });
};
const get = interactiveFunction => __awaiter(void 0, void 0, void 0, function* () {
  const msalClient = yield (0, exports.getMsalClient)();
  msalClient.handleRedirectPromise().then(authResult => {
    (0, handler_1.default)(msalClient, authResult);
    if (interactiveFunction) {
      interactiveFunction(msalClient, authResult);
    }
  }).catch(error => {
    // id token
    removeLocalStorageCache();
    // refresh token
    removeLocalStorageCache();
    msalClient.clearCache();
    (0, error_1.default)(error);
  });
  return msalClient;
});
exports.get = get;
const getMsalClient = () => __awaiter(void 0, void 0, void 0, function* () {
  const config = (0, config_1.default)();
  const msalClient = new msal_browser_1.PublicClientApplication(config);
  yield msalClient.initialize();
  enableLoginLogoutSyncAcrossTabs(msalClient);
  return msalClient;
});
exports.getMsalClient = getMsalClient;
//# sourceMappingURL=index.js.map